import type { OrderLeg } from "../shared/optionLegs/optionLeg.types";
import type {
  TicketOrderType,
  TicketSide,
} from "../widgets/orderTicket/orderTicket.core";

export type WorkspaceEngine = "rgl";

export const ORDER_TICKET_PUSH_QUERY = "(min-width: 800px)";
export const REDUCED_MOTION_QUERY = "(prefers-reduced-motion: reduce)";
export const ORDER_TICKET_DRAWER_WIDTH = "clamp(320px, 32vw, 420px)";

/**
 * The drawer slot contract, shared by the RGL tab so the sticky column stays
 * in step with the ATD shell.
 *
 * The ATD page (`src/v3-poc/pages/index.tsx`) is a `h-dvh` flex column: the
 * header is in normal flow (not fixed), and the workspace fills the remaining
 * height under it. The drawer slot therefore pins at the top of that content
 * pane (`top: 0`) and takes the pane's full height (`100%`) rather than
 * clearing a fixed header with a `--space-*` offset.
 *
 * `Z_INDEX` keeps the portalled drawer above sibling board chrome when the
 * modal overlay paints at the viewport top below 800px.
 */
export const ORDER_TICKET_DRAWER_SLOT_TOP = "0px";
export const ORDER_TICKET_DRAWER_SLOT_HEIGHT = "100%";
export const ORDER_TICKET_DRAWER_SLOT_Z_INDEX = 11;

export interface OrderTicketDraft {
  symbol?: string;
  legs?: OrderLeg[];
  side?: TicketSide;
  quantity?: number;
  orderType?: TicketOrderType;
  limitPrice?: number;
}

export interface OrderTicketDrawerApi {
  openOrderTicket: (draft?: OrderTicketDraft) => void;
  closeOrderTicket: () => void;
  toggleOrderTicket: () => void;
}
